import { useEffect, useState } from "react";

export const breakpoints = {
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1440,
};

export function useScreenResize() {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Call once to set the initial size
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}
